import { createFrontendPlugin, ExtensionDefinition } from '@backstage/frontend-plugin-api';
import PolicyIcon from '@material-ui/icons/Policy';
import { EntityHasAiResourcesCard, EntityMcpServerCard, EntitySkillCard, EntitySimCorpAboutCard, EntitySimCorpSystemCard, GroupRiskCalculatorPage, SystemDataClassificationPage, ToolsPage } from './alpha';
import { createFormField, FormFieldBlueprint } from '@backstage/plugin-scaffolder-react/alpha';
import { AdoPipelineAccessField, AdoPipelineAccessFieldSchema } from './components/AdoPipelineAccessField/AdoPipelineAccessField';
import { ApiDataLoaderField, ApiDataLoaderFieldSchema } from './components/ApiDataLoaderField/ApiDataLoaderField';
import { ArraySelectorField, ArraySelectorFieldSchema } from './components/ArraySelectorField/ArraySelectorField';
import { DataSelectorField, DataSelectorFieldSchema } from './components/DataSelectorField/DataSelectorField';
import { EntraOAuthTokenField, EntraOAuthTokenFieldSchema } from './components/EntraOAuthTokenField/EntraOAuthTokenField';

export const systemDataClassificationPlugin = createFrontendPlugin({
  pluginId: 'simcorp',
  title: 'Data Classification',
  icon: <PolicyIcon />,
  extensions: [
    EntitySimCorpSystemCard,
    EntitySimCorpAboutCard,
    EntityHasAiResourcesCard,
    EntitySkillCard,
    EntityMcpServerCard,
    SystemDataClassificationPage,
    GroupRiskCalculatorPage,
    ToolsPage,
  ]
});

export const AdoPipelineAccessFieldExtension: ExtensionDefinition = FormFieldBlueprint.make({
  name: 'AdoPipelineAccessField',
  params: {
    field: async () =>
      createFormField({
        name: 'AdoPipelineAccess',
        component: AdoPipelineAccessField,
        schema: AdoPipelineAccessFieldSchema,
      }),
  },
});

export const ApiDataLoaderFieldExtension: ExtensionDefinition = FormFieldBlueprint.make({
  name: 'ApiDataLoaderField',
  params: {
    field: async () =>
      createFormField({
        name: 'ApiDataLoader',
        component: ApiDataLoaderField,
        schema: ApiDataLoaderFieldSchema,
      }),
  },
});

export const ArraySelectorFieldExtension: ExtensionDefinition = FormFieldBlueprint.make({
  name: 'ArraySelectorField',
  params: {
    field: async () =>
      createFormField({
        name: 'ArraySelector',
        component: ArraySelectorField,
        schema: ArraySelectorFieldSchema,
      }),
  },
});

export const DataSelectorFieldExtension: ExtensionDefinition = FormFieldBlueprint.make({
  name: 'DataSelectorField',
  params: {
    field: async () =>
      createFormField({
        name: 'DataSelector',
        component: DataSelectorField,
        schema: DataSelectorFieldSchema,
      }),
  },
});

export const EntraOAuthTokenFieldExtension: ExtensionDefinition = FormFieldBlueprint.make({
  name: 'EntraOAuthTokenField',
  params: {
    field: async () =>
      createFormField({
        name: 'EntraOAuthToken',
        component: EntraOAuthTokenField,
        schema: EntraOAuthTokenFieldSchema,
      }),
  },
});
